<div class="form-container">
    <form [formGroup]="form">
        <div>
            <aum-input
                placeholder="{{ 'aumico_notes_super_table_options_title' | i18next }}"
                [simpleInput]="true"
                [aumFormControl]="form.controls['title']"
            >
            </aum-input>
        </div>
        <div>
            <aum-toggle [aumFormControl]="form.controls['compareYears']"
                >{{ 'aumico_notes_input_options_compare_years' | i18next }}
            </aum-toggle>
        </div>
        <div>
            <aum-toggle [aumFormControl]="form.controls['transpose']"
                >{{ 'aumico_notes_super_table_options_transpose' | i18next }}
            </aum-toggle>
        </div>
        <br />
        <div>
            <h2>{{ 'aumico_notes_super_table_options_define_columns' | i18next }}</h2>
        </div>
        <ng-container formArrayName="xAxisConfig">
            <div
                *ngFor="let xAxisConfig of form.get('xAxisConfig')['controls']; let i = index"
                [formGroupName]="i"
                class="horizontal-flex-container"
            >
                <div>
                    <aum-input
                        placeholder="{{ 'aumico_notes_super_table_col_title' | i18next }}"
                        [simpleInput]="true"
                        [aumFormControl]="xAxisConfig.get('title')"
                    >
                    </aum-input>
                </div>
                <aum-select
                    placeholder="{{ 'aumico_notes_super_table_options_col_type' | i18next }}"
                    [aumFormControl]="xAxisConfig.get('type')"
                    [simpleSelect]="true"
                    [options]="xAxisConfigColTypesSelections"
                >
                    <aum-form-error
                        *ngIf="xAxisConfig.controls['type'].touched && xAxisConfig.controls['type'].invalid"
                    >
                        <span *ngIf="xAxisConfig.controls['type'].errors['required']">{{
                            'aumico_annual_report_mandatory_field_error' | i18next
                        }}</span>
                    </aum-form-error>
                </aum-select>

                <aum-select
                    placeholder="{{ 'aumico_notes_super_table_options_col_belonging_year' | i18next }}"
                    [aumFormControl]="xAxisConfig.get('belongingYear')"
                    [simpleSelect]="true"
                    [options]="xAxisConfigColBelongingYearSelections"
                >
                    <aum-form-error
                        *ngIf="
                            xAxisConfig.controls['belongingYear'].touched &&
                            xAxisConfig.controls['belongingYear'].invalid
                        "
                    >
                        <span *ngIf="xAxisConfig.controls['belongingYear'].errors['required']">{{
                            'aumico_annual_report_mandatory_field_error' | i18next
                        }}</span>
                    </aum-form-error>
                </aum-select>
                <mat-icon
                    (click)="removeXAxisConfigCol(i)"
                    class="remove-icon"
                    svgIcon="aumico-pattern-icon-remove"
                ></mat-icon>
            </div>
            <button aum-icon-button color="basic" icon="plus" type="button" (click)="addXAxisConfigCol()">
                {{ 'aumico_annual_report_cash_flow_add_new_item' | i18next }}
            </button>
        </ng-container>
        <br />
        <br />
        <div>
            <h2>{{ 'aumico_notes_super_table_options_define_segments' | i18next }}</h2>
        </div>
        <ng-container formArrayName="segments">
            <div
                *ngFor="let segment of form.get('segments')['controls']; let i = index"
                [formGroupName]="i"
                class="horizontal-flex-container"
            >
                <div>
                    <aum-input
                        placeholder="{{ 'aumico_notes_super_table_segment_title' | i18next }}"
                        [simpleInput]="true"
                        [aumFormControl]="segment.get('title')"
                    >
                    </aum-input>
                </div>
                <aum-draggable-multi-select
                    placeholder="{{ 'aumico_notes_super_table_segment_child_columns' | i18next }}"
                    [aumFormControl]="segment.get('childColsIds')"
                    [options]="columnOptions"
                >
                    >
                    <aum-form-field-label>
                        {{ 'aumico_notes_super_table_segment_child_columns' | i18next }}
                    </aum-form-field-label>
                    <aum-form-error *ngIf="segment.controls['childColsIds'].hasError('required')">
                        {{ 'aumico_annual_report_mandatory_field_error' | i18next }}
                    </aum-form-error>
                </aum-draggable-multi-select>

                <mat-icon
                    (click)="removeSegment(i)"
                    class="remove-icon"
                    svgIcon="aumico-pattern-icon-remove"
                ></mat-icon>
            </div>
            <button aum-icon-button color="basic" icon="plus" type="button" (click)="addSegment()">
                {{ 'aumico_annual_report_cash_flow_add_new_item' | i18next }}
            </button>
        </ng-container>
        <div class="save-button">
            <button [disabled]="form.invalid" class="btn btn-success m-1" (click)="onSaveButtonClick()">
                {{ 'aumico_button_save' | i18next }}
            </button>
        </div>
    </form>
</div>
